// Built-in import
import * as React from "react";

// External import
import { Grid, Paper, Stack, SxProps, Typography } from "@mui/material";

import AddExecutiveCalenderSidebar from "./sidebar/add";
import EditExecutiveCalenderSidebar from "./sidebar/edit";
import ExecutiveCalendarCards from "./cards";
import { IEvent } from "@/types/event";
import { IServerProperty } from "@/store/slices/property";
import { propertySelector } from "@/store/slices/property/selectors";
import { useAppSelector } from "@/store/store";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Internal import

interface IExecutiveCalender {
  sxProps?: SxProps;
  events?: IEvent[];
  onFetchAllEvents: () => void;
  isInvestor?: boolean;
}

const ExecutiveCalender: React.FC<IExecutiveCalender> = ({
  sxProps,
  events = [],
  onFetchAllEvents,
  isInvestor = false,
}) => {
  const property = useAppSelector(propertySelector) as IServerProperty;

  const { id: isEdit } = useParams();

  // Getting translation object
  const { t } = useTranslation(["common"]);

  //setting received events

  const [receivedItems, setReceivedItems] = React.useState<IEvent[]>([]);

  React.useEffect(() => {
    if (events.length) {
      setReceivedItems(events);
    }
  }, [events]);

  return (
    <Stack>
      <ExecutiveCalendarCards
        onFetchAllEvents={onFetchAllEvents}
        property={property as IServerProperty}
        isInvestor={isInvestor}
        events={receivedItems}
        {...(isEdit && { propertyId: property.id })}
      />
    </Stack>
  );
};

export default ExecutiveCalender;
